import getTextFromPairs from '@/services/text/get-text-from-general-hands/get-text-from-pairs';
import getTextFromSuitedGeneralHands from '@/services/text/get-text-from-general-hands/get-text-from-suited-general-hands';
import getTextFromOffsuitGeneralHands from '@/services/text/get-text-from-general-hands/get-text-from-offsuit-general-hands';

export default {
  inRange: function (generalHands) {
    let textString = '';

    textString += getTextFromPairs.inRange(generalHands);
    textString += getTextFromSuitedGeneralHands.inRangeWithFirstRank(generalHands, 'a');
    textString += getTextFromOffsuitGeneralHands.inRangeWithFirstRank(generalHands, 'a');
    textString += getTextFromSuitedGeneralHands.inRangeWithFirstRank(generalHands, 'k');
    textString += getTextFromOffsuitGeneralHands.inRangeWithFirstRank(generalHands, 'k');
    textString += getTextFromSuitedGeneralHands.inRangeWithFirstRank(generalHands, 'q');
    textString += getTextFromOffsuitGeneralHands.inRangeWithFirstRank(generalHands, 'q');
    textString += getTextFromSuitedGeneralHands.inRangeWithFirstRank(generalHands, 'j');
    textString += getTextFromOffsuitGeneralHands.inRangeWithFirstRank(generalHands, 'j');
    textString += getTextFromSuitedGeneralHands.inRangeWithFirstRank(generalHands, 't');
    textString += getTextFromOffsuitGeneralHands.inRangeWithFirstRank(generalHands, 't');
    textString += getTextFromSuitedGeneralHands.inRangeWithFirstRank(generalHands, '9');
    textString += getTextFromOffsuitGeneralHands.inRangeWithFirstRank(generalHands, '9');
    textString += getTextFromSuitedGeneralHands.inRangeWithFirstRank(generalHands, '8');
    textString += getTextFromOffsuitGeneralHands.inRangeWithFirstRank(generalHands, '8');
    textString += getTextFromSuitedGeneralHands.inRangeWithFirstRank(generalHands, '7');
    textString += getTextFromOffsuitGeneralHands.inRangeWithFirstRank(generalHands, '7');
    textString += getTextFromSuitedGeneralHands.inRangeWithFirstRank(generalHands, '6');
    textString += getTextFromOffsuitGeneralHands.inRangeWithFirstRank(generalHands, '6');
    textString += getTextFromSuitedGeneralHands.inRangeWithFirstRank(generalHands, '5');
    textString += getTextFromOffsuitGeneralHands.inRangeWithFirstRank(generalHands, '5');
    textString += getTextFromSuitedGeneralHands.inRangeWithFirstRank(generalHands, '4');
    textString += getTextFromOffsuitGeneralHands.inRangeWithFirstRank(generalHands, '4');
    textString += getTextFromSuitedGeneralHands.inRangeWithFirstRank(generalHands, '3');
    textString += getTextFromOffsuitGeneralHands.inRangeWithFirstRank(generalHands, '3');
    textString = textString.replace(/a/g, 'A');
    textString = textString.replace(/k/g, 'K');
    textString = textString.replace(/q/g, 'Q');
    textString = textString.replace(/j/g, 'J');
    textString = textString.replace(/t/g, 'T');
    textString = textString.slice(0, -2); // remove trailing comma

    return textString;
  },
  manuallyAdded: function (generalHands) {
    let textString = '';

    textString += getTextFromPairs.manuallyAdded(generalHands);
    textString += getTextFromSuitedGeneralHands.manuallyAddedWithFirstRank(generalHands, 'a');
    textString += getTextFromOffsuitGeneralHands.manuallyAddedWithFirstRank(generalHands, 'a');
    textString += getTextFromSuitedGeneralHands.manuallyAddedWithFirstRank(generalHands, 'k');
    textString += getTextFromOffsuitGeneralHands.manuallyAddedWithFirstRank(generalHands, 'k');
    textString += getTextFromSuitedGeneralHands.manuallyAddedWithFirstRank(generalHands, 'q');
    textString += getTextFromOffsuitGeneralHands.manuallyAddedWithFirstRank(generalHands, 'q');
    textString += getTextFromSuitedGeneralHands.manuallyAddedWithFirstRank(generalHands, 'j');
    textString += getTextFromOffsuitGeneralHands.manuallyAddedWithFirstRank(generalHands, 'j');
    textString += getTextFromSuitedGeneralHands.manuallyAddedWithFirstRank(generalHands, 't');
    textString += getTextFromOffsuitGeneralHands.manuallyAddedWithFirstRank(generalHands, 't');
    textString += getTextFromSuitedGeneralHands.manuallyAddedWithFirstRank(generalHands, '9');
    textString += getTextFromOffsuitGeneralHands.manuallyAddedWithFirstRank(generalHands, '9');
    textString += getTextFromSuitedGeneralHands.manuallyAddedWithFirstRank(generalHands, '8');
    textString += getTextFromOffsuitGeneralHands.manuallyAddedWithFirstRank(generalHands, '8');
    textString += getTextFromSuitedGeneralHands.manuallyAddedWithFirstRank(generalHands, '7');
    textString += getTextFromOffsuitGeneralHands.manuallyAddedWithFirstRank(generalHands, '7');
    textString += getTextFromSuitedGeneralHands.manuallyAddedWithFirstRank(generalHands, '6');
    textString += getTextFromOffsuitGeneralHands.manuallyAddedWithFirstRank(generalHands, '6');
    textString += getTextFromSuitedGeneralHands.manuallyAddedWithFirstRank(generalHands, '5');
    textString += getTextFromOffsuitGeneralHands.manuallyAddedWithFirstRank(generalHands, '5');
    textString += getTextFromSuitedGeneralHands.manuallyAddedWithFirstRank(generalHands, '4');
    textString += getTextFromOffsuitGeneralHands.manuallyAddedWithFirstRank(generalHands, '4');
    textString += getTextFromSuitedGeneralHands.manuallyAddedWithFirstRank(generalHands, '3');
    textString += getTextFromOffsuitGeneralHands.manuallyAddedWithFirstRank(generalHands, '3');
    textString = textString.replace(/a/g, 'A');
    textString = textString.replace(/k/g, 'K');
    textString = textString.replace(/q/g, 'Q');
    textString = textString.replace(/j/g, 'J');
    textString = textString.replace(/t/g, 'T');
    textString = textString.slice(0, -2); // remove trailing comma

    return textString;
  },
  manuallyRemoved: function (generalHands) {
    let textString = '';

    textString += getTextFromPairs.manuallyRemoved(generalHands);
    textString += getTextFromSuitedGeneralHands.manuallyRemovedWithFirstRank(generalHands, 'a');
    textString += getTextFromOffsuitGeneralHands.manuallyRemovedWithFirstRank(generalHands, 'a');
    textString += getTextFromSuitedGeneralHands.manuallyRemovedWithFirstRank(generalHands, 'k');
    textString += getTextFromOffsuitGeneralHands.manuallyRemovedWithFirstRank(generalHands, 'k');
    textString += getTextFromSuitedGeneralHands.manuallyRemovedWithFirstRank(generalHands, 'q');
    textString += getTextFromOffsuitGeneralHands.manuallyRemovedWithFirstRank(generalHands, 'q');
    textString += getTextFromSuitedGeneralHands.manuallyRemovedWithFirstRank(generalHands, 'j');
    textString += getTextFromOffsuitGeneralHands.manuallyRemovedWithFirstRank(generalHands, 'j');
    textString += getTextFromSuitedGeneralHands.manuallyRemovedWithFirstRank(generalHands, 't');
    textString += getTextFromOffsuitGeneralHands.manuallyRemovedWithFirstRank(generalHands, 't');
    textString += getTextFromSuitedGeneralHands.manuallyRemovedWithFirstRank(generalHands, '9');
    textString += getTextFromOffsuitGeneralHands.manuallyRemovedWithFirstRank(generalHands, '9');
    textString += getTextFromSuitedGeneralHands.manuallyRemovedWithFirstRank(generalHands, '8');
    textString += getTextFromOffsuitGeneralHands.manuallyRemovedWithFirstRank(generalHands, '8');
    textString += getTextFromSuitedGeneralHands.manuallyRemovedWithFirstRank(generalHands, '7');
    textString += getTextFromOffsuitGeneralHands.manuallyRemovedWithFirstRank(generalHands, '7');
    textString += getTextFromSuitedGeneralHands.manuallyRemovedWithFirstRank(generalHands, '6');
    textString += getTextFromOffsuitGeneralHands.manuallyRemovedWithFirstRank(generalHands, '6');
    textString += getTextFromSuitedGeneralHands.manuallyRemovedWithFirstRank(generalHands, '5');
    textString += getTextFromOffsuitGeneralHands.manuallyRemovedWithFirstRank(generalHands, '5');
    textString += getTextFromSuitedGeneralHands.manuallyRemovedWithFirstRank(generalHands, '4');
    textString += getTextFromOffsuitGeneralHands.manuallyRemovedWithFirstRank(generalHands, '4');
    textString += getTextFromSuitedGeneralHands.manuallyRemovedWithFirstRank(generalHands, '3');
    textString += getTextFromOffsuitGeneralHands.manuallyRemovedWithFirstRank(generalHands, '3');
    textString = textString.replace(/a/g, 'A');
    textString = textString.replace(/k/g, 'K');
    textString = textString.replace(/q/g, 'Q');
    textString = textString.replace(/j/g, 'J');
    textString = textString.replace(/t/g, 'T');
    textString = textString.slice(0, -2); // remove trailing comma

    return textString;
  },
};



// WEBPACK FOOTER //
// ./src/services/text/get-text-from-general-hands/get-text-from-general-hands.js